<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'App',
}
</script>

<style lang="scss">
body, html {
  margin: 0;
  padding: 0;
  position: static !important;
}

* {
  // transition: all 0.2s ease-in-out;
}

button, a {
  &:hover, &:active, &:focus {
    outline: none;
  }
}

#k-logo {
  @media screen and (max-width: $break-mobile) {
    position: absolute;
    top: 30px;
    max-width: 30px;
  }
}

#app {
  margin: 0;
  padding: 0;

  font-family: Montserrat;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 20px;
  color: $color-black;
}

input, p {
  font-size: 20px;

  @media screen and (max-width: $break-mobile) {
    font-size: 16px;
  }
}

.container {
  width: calc(100% - #{$container-padding *2});
  max-width: $container-width;
  margin: auto;
  padding: 0 $container-padding;

  @media screen and (max-width: $break-mobile) {
    width: calc(100% - #{$container-padding-mobile} * 2);
    padding: 0 $container-padding-mobile;
    max-width: initial;
  }
}

h1 {
  margin: 0;
  padding: 0;
  font-weight: 500;
  font-size: 70px;
  line-height: 1.1;
  text-transform: uppercase;
}

h2 {
  margin: 0;
  padding: 0;
  font-weight: 600;
  font-size: 30px;

  @media screen and (max-width: $break-mobile) {
    font-size: 25px;
  }
}

h3 {
  font-weight: 600;
  font-size: 20px;
}

h4 {
  font-weight: normal;
  font-size: 20px;
}

a {
  color: $color-black;
}

p {
  line-height: 1.45;
}

p.large, div.large p {
  font-size: 25px;

  @media screen and (max-width: $break-mobile) {
    font-size: 20px;
  }
}

/** The title and taglines **/
h1 + p.large, h1 + div.large p {
  margin-top: 1.5em;
  padding-top: 0;
}

.fullwidth h1 + div.large p {
  margin: 0.4em 0;
}

.fullwidth div.large p {
    @media screen and (max-width: $break-container) {
      font-size: 16px;
      line-height: 1.2;
   }
}


/** How to take part section **/
section.fullwidth + div.container #start {

    @media screen and (max-width: 1500px) {
      max-width: 80%;
      width: unset;
    }

    @media screen and (max-width: $break-container) {
      max-width: 90%;
    }

    @media screen and (max-width:650px) {
        max-width: 100%;
    }
}

/** Font size in the title section fits smaller - so reduce rest of p **/
section.fullwidth ~ div.container p {
    @media screen and (max-width: $break-container) {
      font-size: 16px;
    }
}



p.large + p.cta-container, div.large + p.cta-container {
  margin-top: 4em;
  margin-bottom: 0;
  padding-top: 0;
  padding-bottom: 0;

  @media screen and (max-width: $break-mobile) {
    margin-top: 2em;
  }
}

p + p.cta-container {
  margin-top: 2em;
}

p.small {
  font-size: 16px;
}

label {
  // https://stackoverflow.com/a/4407335
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently supported by Chrome, Edge, Opera and Firefox */
}
</style>
